import { render } from "./SaveStatus.vue?vue&type=template&id=8204055e&scoped=true"
import script from "./SaveStatus.vue?vue&type=script&lang=js"
export * from "./SaveStatus.vue?vue&type=script&lang=js"

import "./SaveStatus.vue?vue&type=style&index=0&id=8204055e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8204055e"

export default script